import { render, staticRenderFns } from "./confirmOutStock.vue?vue&type=template&id=32a97462&scoped=true&"
import script from "./confirmOutStock.vue?vue&type=script&lang=js&"
export * from "./confirmOutStock.vue?vue&type=script&lang=js&"
import style0 from "./confirmOutStock.vue?vue&type=style&index=0&id=32a97462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a97462",
  null
  
)

export default component.exports